import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { ImageLoaderService } from '@boels/helpers';
import { BoelsBaseSite, BoelsBaseSiteLanguage, Language } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { LanguageSelectorModalItemLinkComponent } from './language-selector-modal-item-link/language-selector-modal-item-link.component';

@Component({
  selector: 'boels-language-selector-modal-item',
  templateUrl: './language-selector-modal-item.component.html',
  styleUrls: ['./language-selector-modal-item.component.scss'],
  imports: [
    LanguageSelectorModalItemLinkComponent,
    CommonModule,
    FontAwesomeModule,
  ],
  providers: [ImageLoaderService],
})
export class LanguageSelectorModalItemComponent implements OnChanges {
  protected imageLoaderService = inject(ImageLoaderService);

  private readonly flagsFolderUrl = '/assets/images/icons/flags/Flag_';

  @Input() baseSite: BoelsBaseSite;
  @Output() baseSiteLanguageEventEmitter: EventEmitter<BoelsBaseSiteLanguage> =
    new EventEmitter();

  imageUrl: string;
  faChevronRight = faChevronRight;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['baseSite']) {
      this.imageUrl = this.imageLoaderService.getImagePath(
        this.flagsFolderUrl,
        this.baseSite?.country?.isocode as string,
      );
    }
  }

  emitBaseSiteLanguage(language: Language): void {
    const boelsBaseSiteLanguage: BoelsBaseSiteLanguage = {
      language,
      baseSite: this.baseSite,
    };
    this.baseSiteLanguageEventEmitter.emit(boelsBaseSiteLanguage);
  }

  trackByIsoCode(index: number, language: Language): string {
    return language.isocode as string;
  }
}
